<template>
  <v-dialog persistent v-model="show" width="80%">
    <v-card>
      <v-card-title>
        <span class="headline">事前納入指示依頼メール送信画面</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="save()" class="btn-search">保存</v-btn>
        <v-btn @click="close()">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-autocomplete
                :items="employees"
                clearable
                label="納入指示者"
                persistent-hint
                returnObject
                v-model="newDirector"
              >
                <template slot="append-outer">
                  <v-icon
                    @click="addNewDirector"
                    color="success"
                    v-text="'add'"
                  ></v-icon>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-card>
            <v-chip-group column multiple>
              <v-chip
                :key="chip.id"
                @input="remove(chip)"
                close
                color="orange"
                outline
                v-for="chip in chips"
                >{{ chip.text }}</v-chip
              >
            </v-chip-group>
          </v-card>
          <v-layout row wrap>
            <v-flex xs3>
              <remote-autocomplete
                :disabled="true"
                :label="$t('app.labels.bu.name')"
                :rules="[
                  (v) =>
                    !!v ||
                    $t('app.labels.bu.name') +
                      $t('app.validator.messages.required'),
                ]"
                required
                url="divisions/kv?type=BU"
                v-model="buId"
              />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.department.name')"
                returnObject
                url="divisions/kv?type=DEPARTMENT"
                v-model="department"
              />
            </v-flex>
            <v-flex xs3>
              <v-btn
                :disabled="selected.length !== 1"
                @click="addExistDirectors"
                >追加</v-btn
              >
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <v-data-table
        :headers="$store.state.deliveryDirectorHeader"
        :items="showDirectors"
        :rows-per-page-items="[10]"
        class="elevation-0"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td width="20">
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.buCode + ':' + props.item.buName }}</td>
          <td>
            {{ props.item.departmentCode + ':' + props.item.departmentName }}
          </td>

          <td>{{ props.item.productName }}</td>
          <td>
            {{
              props.item.classificationName == null
                ? classificationMapper(props.item.classificationId)
                : props.item.classificationName
            }}
          </td>
          <td>{{ props.item.deliveryDirectorName1 }}</td>
          <td>{{ props.item.deliveryDirectorName2 }}</td>
          <td>{{ props.item.deliveryDirectorName3 }}</td>
          <td>{{ props.item.deliveryDirectorName4 }}</td>
          <td>{{ props.item.deliveryDirectorName5 }}</td>
          <td>{{ props.item.deliveryDirectorName6 }}</td>
          <td>{{ props.item.deliveryDirectorName7 }}</td>
          <td>{{ props.item.deliveryDirectorName8 }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      directors: [],
      showDirectors: [],
      query: {},
      pagination: {},
      selected: [],
      employees: [],
      finalDeliveryDirectors: [],
      newDirector: {},
      chips: [],
      buId: null,
      department: null,
      shipment: {},
    }
  },
  methods: {
    close() {
      this.show = false
      this.directors = []
      this.showDirectors = []
      this.selected = []
      this.employees = []
      this.finalDeliveryDirectors = []
      this.chips = []
      this.buId = null
      this.department = null
      this.shipment = {}
    },
    addExistDirectors() {
      var ids = []
      var director = this.selected[0]
      var d1 = director.deliveryDirectorId1
      var d2 = director.deliveryDirectorId2
      var d3 = director.deliveryDirectorId3
      var d4 = director.deliveryDirectorId4
      var d5 = director.deliveryDirectorId5
      var d6 = director.deliveryDirectorId6
      var d7 = director.deliveryDirectorId7
      var d8 = director.deliveryDirectorId8
      ids.push({ id: d1 })
      ids.push({ id: d2 })
      ids.push({ id: d3 })
      ids.push({ id: d4 })
      ids.push({ id: d5 })
      ids.push({ id: d6 })
      ids.push({ id: d7 })
      ids.push({ id: d8 })
      if (this.findSameEmployee(ids)) {
        this.$message('', '該当納入指示者が既に存在しています。')
        this.selected = []
        return
      }

      this.finalDeliveryDirectors = [...this.finalDeliveryDirectors, ...ids]
      this.pushToChips(director.deliveryDirectorName1, d1)
      this.pushToChips(director.deliveryDirectorName2, d2)
      this.pushToChips(director.deliveryDirectorName3, d3)
      this.pushToChips(director.deliveryDirectorName4, d4)
      this.pushToChips(director.deliveryDirectorName5, d5)
      this.pushToChips(director.deliveryDirectorName6, d6)
      this.pushToChips(director.deliveryDirectorName7, d7)
      this.pushToChips(director.deliveryDirectorName8, d8)
      this.chips = [...this.chips.filter((c) => c.text)]
      this.finalDeliveryDirectors = [
        ...this.finalDeliveryDirectors.filter((f) => f.id),
      ]
      this.selected = []
    },
    pushToChips(name, id) {
      this.chips.push({
        text: name,
        value: id,
      })
    },
    addNewDirector() {
      if (this.newDirector.value == null) {
        this.$message('', '納入指示者がブランクできません。')
      } else if (this.findSameEmployee([{ id: this.newDirector.value }])) {
        this.$message('', '該当納入指示者が既に存在しています。')
      } else {
        this.chips = [
          ...this.chips,
          {
            text: this.newDirector.text,
            value: this.newDirector.value,
          },
        ]
        this.finalDeliveryDirectors = [
          ...this.finalDeliveryDirectors,
          {
            id: this.newDirector.value,
          },
        ]
      }
    },
    remove(item) {
      this.$confirm({ content: '削除してよろしいでしょうか？' }).then(() => {
        console.log(item)
        this.chips.forEach((c, index) => {
          if (c.value === item.value) {
            this.chips.splice(index, 1)
          }
        })
        this.finalDeliveryDirectors.forEach((c, index) => {
          if (c.id === item.value) {
            this.finalDeliveryDirectors.splice(index, 1)
          }
        })
      })
    },
    popup(data, shipment) {
      this.loadEmployee()
      this.show = true
      this.directors = [...data]
      this.showDirectors = [...data]
      this.buId = data && data[0].buId
      this.$http.get(`/shipping-advices/${shipment.id}`).then((res) => {
        this.shipment = res.data

        this.shipment.directors.forEach((d) => {
          this.chips = [
            ...this.chips,
            {
              text: d.fullName + ':' + d.email,
              value: d.id,
            },
          ]
        })
        this.finalDeliveryDirectors = this.shipment.directors
      })
    },
    save() {
      return this.$http
        .put(
          `shipping-advices/${this.shipment.id}/set-delivery-director`,
          this.finalDeliveryDirectors
        )
        .then(() => {
          this.$message('', '保存が完了しました。')
          this.initInfo()
        })
    },
    initInfo() {
      this.finalDeliveryDirectors = []
      this.directors = {}
      this.newDirector = {}
      this.chips = []
      this.show = false

      this.$emit('refresh')
    },
    loadEmployee() {
      this.$http.get('employees/email-kv').then((res) => {
        res.data.forEach((d) => {
          this.employees = [...this.employees, d]
        })
      })
    },
    loadDirectors(id) {},
    findSameEmployee(ids) {
      for (var i = 0; i < this.finalDeliveryDirectors.length; i++) {
        if (
          ids.filter((e) => e.id === this.finalDeliveryDirectors[i].id).length >
          0
        ) {
          return true
        }
      }
      return false
    },
    classificationMapper(item) {
      if (!item) return ''
      switch (item) {
        case 1:
          return '完成品'
        case 2:
          return '部件'
        case 3:
          return 'サービスパーツ'
        default:
          return 'その他'
      }
    },
  },
  watch: {
    department() {
      if (!this.department) {
        return (this.showDirectors = this.directors)
      }
      this.showDirectors = this.directors.filter(
        (d) => d.departmentCode === this.department.code
      )
    },
  },
}
</script>

<style>
</style>
